import { Injectable } from '@angular/core';
declare var THREE: any;
import { StageService } from './stage.service';
import { SceneUtilsService } from './scene-utils.service';
import { ComponentBase } from '../component-base';
import { ImageUtilsService } from './image-utils.service';
import { Select3dService } from './select-3d.service';
import { RailingGenerationService } from './railing/services/railing-generation.service'
import {AutoScaleSprite} from '../custom/AutoScaleSprite';

@Injectable()
export class RemoveTierService extends ComponentBase {

  constructor(
    private stage: StageService,
    private sceneUtils: SceneUtilsService,
    private imageUtilsService: ImageUtilsService,
    private select3dService: Select3dService,
    private railingGenerationService: RailingGenerationService
  ) {
    super();
    this.disable();
  }

  sprites = [];
  loader = new THREE.TextureLoader();
  isActive = false;
  private raycaster: any = new THREE.Raycaster();

  drawSprites() {

    let floors = this.stage.getCompoundFloor();

    for (let i = 0; i < floors.children.length; i++) {
      const floor = floors.children[i];
      if (!floor.userData.mainFloor && floor.userData.isOuterTier) {
        let box = new THREE.Box3();
        box.setFromObject(floor);
        let center = new THREE.Vector3();
        box.getCenter(center);
        center.y = floor.position.y + floors.position.y;

        var spriteMap = this.loader.load('../../assets/images/sprites/remove.png');

        var spriteMaterial = new THREE.SpriteMaterial({ map: spriteMap, color: 0xffffff, depthTest: false, depthWrite: false });

        var sprite = new AutoScaleSprite(50, 50, spriteMaterial);
        sprite.userData.floor = floor;
        sprite.position.copy(center);

        this.stage.add(sprite);
        this.sprites.push(sprite);
      }
    }
  }

  mouseDown(e: MouseEvent): void {
    var p = this.sceneUtils.getRay(e.offsetX, e.offsetY);
    this.raycaster.ray.origin.copy(p.ray.origin);
    this.raycaster.ray.direction.copy(p.ray.direction);

    var intersection = this.raycaster.intersectObjects(this.sprites);
    if (intersection.length) {
      let tier = intersection[0].object.userData.floor;
      tier.userData.edge.firstPoint.superstructureType = null;
      this.removeTier(tier);

      let parentTier = this.stage.getCompoundFloor().children.find(tier => tier.userData.customId === intersection[0].object.userData.floor.userData.parentCustomId);
      parentTier.userData.isOuterTier = true;
      let parentPoint = parentTier.userData.points.find(point => point.childCustomId === tier.userData.customId);
      parentPoint.superstructureType = null;
      parentPoint.childCustomId = null;
      parentPoint.tierId = null;

      this.setParentTierAsOuterTier(intersection[0].object.userData.floor.userData.parentCustomId);

      this.imageUtilsService.drawTextSprites();
      this.railingGenerationService.buildRailing(this.railingGenerationService.IsVisible());

      this.removeSprites();
      this.disable();
    }
  }

  removeSprites() {
    this.stage.removeMany(this.sprites);
    this.sprites = [];
  }

  removeTier(tier) {
    let compoundFloor = this.stage.getCompoundFloor();
    this.stage.remove(tier);
    compoundFloor.children.length && this.select3dService.setSelectedTier(compoundFloor.children[0]);
  }

  disable() {
    this.removeSprites();
    super.disable();
  }

  private setParentTierAsOuterTier(floorID) {
    let floors = this.stage.getCompoundFloor();

    for (let i = 0; i < floors.children.length; i++) {
      const tier = floors.children[i];
      if (tier.userData.customId === floorID) {
        tier.userData.isOuterTier = true;
      }
    }
  }

}



// WEBPACK FOOTER //
// ./src/app/services/remove-tier.service.ts